import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';
import { cn } from '../../lib/cn.js';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label?: ReactNode;
};

export const Checkbox = forwardRef<HTMLInputElement, Props>(function Checkbox(
  { label, className, disabled, ...rest },
  ref,
) {
  return (
    <label
      className={cn(
        'inline-flex items-center gap-2 cursor-pointer select-none text-sm text-ink-soft',
        disabled && 'opacity-50 cursor-not-allowed',
        className,
      )}
    >
      <input
        ref={ref}
        type="checkbox"
        disabled={disabled}
        className={cn(
          'h-4 w-4 rounded border-line text-navy',
          'focus:ring-2 focus:ring-navy/30 focus:ring-offset-0',
          'cursor-pointer disabled:cursor-not-allowed',
        )}
        {...rest}
      />
      {label != null && <span>{label}</span>}
    </label>
  );
});
